export const easing = {
  easeOut: 'cubic-bezier(0.55, 0, 0.1, 1)',
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/styles/animation.ts